import React, { Fragment } from "react";
import { useSrmAuthenticationContext } from "./srm-authentication-context";
import { Button, Card, CardContent, CardHeader, LinearProgress, Typography } from "@mui/material";
import { Refresh } from "@mui/icons-material";
import { t } from "i18next";

import "./style.scss";

export const SrmAuthenticationScreen = () => {
    const authenticationContext = useSrmAuthenticationContext();

    const handleRetry = () => {
        if (!authenticationContext.isAuthenticated) {
            authenticationContext.login();
        }
    };

    return <div className={"login-page"}>
        <Card className={"login-page__content"} variant={"outlined"}>
            {!authenticationContext.isInitialized ?
                <LoginPageProgress /> :
                <LoginPageUnauthorized onRetry={handleRetry} />}
        </Card>
    </div>;
};

export const LoginPageProgress = () => {
    return <Fragment>
        <CardHeader title={<Typography variant={"h5"} color={"textPrimary"}>
            {t("components.srmBlueBrandReturns.authentication.progress.title")}
        </Typography>} />
        <CardContent>
            <LinearProgress />
        </CardContent>
    </Fragment>;
};

export const LoginPageUnauthorized = ({ onRetry }: { onRetry: () => void }) => {
    return <Fragment>
        <CardHeader title={<Typography variant={"h5"} color={"textPrimary"}>
            {t("components.srmBlueBrandReturns.authentication.failed.title")}
        </Typography>}
                    action={<Button variant={"outlined"}
                                    color={"primary"}
                                    onClick={onRetry}
                                    startIcon={<Refresh />}>{t("components.srmBlueBrandReturns.authentication.failed.refreshButton")}</Button>} />
        <CardContent>
            <Typography variant={"body1"}>
                {t("components.srmBlueBrandReturns.authentication.failed.description")}
            </Typography>
        </CardContent>
    </Fragment>;
};
